import {SettingsRoutes} from "@settings/Routes";
import {LeadGenerationRoutes} from "@lead-generation/Routes";
import {AIServiceRoutes} from "@ai-services/Routes";
import {GlobalRoutePath} from "./constants"

const Login = /* #__LOADABLE__ */() => import("@components/Authentication/Login");
const Signup = /* #__LOADABLE__ */() => import("@components/Authentication/Signup");
const SignUpConfirm = /* #__LOADABLE__ */() => import("@components/Authentication/SignupConfirm");
const ForgotPassword = /* #__LOADABLE__ */() => import("@components/Authentication/ForgotPassword");
const ForgotPasswordConfirm = /* #__LOADABLE__ */() => import("@components/Authentication/ForgotPasswordConfirm");
const ChangePassword = /* #__LOADABLE__ */() => import("@components/Authentication/ChangePassword");
const TermsAndConditions = /* #__LOADABLE__ */() => import("@components/Authentication/TermsConditions");
const Home = /* #__LOADABLE__ */() => import("@components/Home");

const Dashboard = /* #__LOADABLE__ */() => import("@components/Dashboard");

const LeadGeneration = /* #__LOADABLE__ */() => import("@components/LeadGeneration");
const UserProfile = /* #__LOADABLE__ */() => import("@components/UserProfile");

const ADTAutomation = /* #__LOADABLE__ */() => import("@components/Services/ADTAutomation");
const ADTAutomationHistory = /* #__LOADABLE__ */() => import("@components/Services/ADTAutomation/UploadFileHistory");

const Settings = /* #__LOADABLE__ */() => import("@components/Settings");
const AIService = /* #__LOADABLE__ */() => import("@components/AIServices");
const Referral360 = /* #__LOADABLE__ */() => import("@components/Services/Referral360");

const Patient360 = /* #__LOADABLE__ */() => import("@components/Services/Patient360");

const PatientTrial = /* #__LOADABLE__ */() => import("@components/Services/PatientTrial");
const SmartScheduler = /* #__LOADABLE__ */() => import("@components/Services/SmartScheduler");

const EFax = /* #__LOADABLE__ */() => import('@components/Services/EFax');
const PracticeListingPage = () => import('@components/PracticeManagement/ListingPage');
const ExecutedListingIndex = () => import('@components/PracticeManagement/JobsAndTasks/ExecutedListingIndex');

const DownloadCenterUpload = () => import('@components/DownloadCenter/DownloadCenterUpload');
const DownloadCenterViewFiles = () => import('@components/DownloadCenter/DownloadCenterViewFiles');

const Routes = {
  LOGIN: {
    name: "login",
    layout:"withRegistrationHeader",
    loadablComp:Login,
    layoutOpt:{headerClass:'no-logo'}
    //componentPath: '@components/Authentication/Login',
  },
  SIGNUP: {
    name: "signup",
    layout:"withRegistrationHeader",
    loadablComp:Signup,
    layoutOpt:{headerClass:'no-logo'}
    //componentPath: '../components/Authentication/Signup',
  },
  SIGNUP_CONFIRM: {
    name: "signup confirm",
    layout:"withRegistrationHeader",
    loadablComp:SignUpConfirm,
    layoutOpt:{headerClass:'no-logo'}
    //componentPath: '@components/Authentication/SignupConfirm',
  },
  FORGOT_PASSWORD: {
    name: "forgot password",
    layout:"withRegistrationHeader",
    loadablComp:ForgotPassword,
    layoutOpt:{headerClass:'no-logo'}
    //componentPath: '@components/Authentication/ForgotPassword',
  },
  FORGOT_PASSWORD_CONFIRM: {
    name: "forgot password confirmation",
    layout:"withRegistrationHeader",
    loadablComp:ForgotPasswordConfirm,
    layoutOpt:{headerClass:'no-logo'}
    //componentPath: '@components/Authentication/ForgotPasswordConfirm',
  },
  CHANGE_PASSWORD: {
    name: "change password",
    layout:"withHeader",
    authRequired:true,
    loadablComp:ChangePassword,
    layoutOpt:{showLeftMenu:false,contentClass:'page-content p-0',containerClass:'no-scroll'},
    //componentPath: '@components/Authentication/ChangePassword',
  },
  TERMS_AND_CONDITIONS: {
    name: "terms and conditions",
    layout:"withRegistrationHeader",
    loadablComp:TermsAndConditions,
    //componentPath: '@components/Authentication/TermsConditions',
  },
  LEAD_GENERATION: {
    name: "lead generation",
    authRequired:true,
    layout:"withWhiteBgLogo",
    nextedRoutes:LeadGenerationRoutes,
    loadablComp:LeadGeneration,
    //componentPath: '@components/Authentication/Login',
  },
  DEFAULT: {
    name: "home",
    exact:true,
    layout:"withPlainHeader",
    loadablComp:Home
  },
  HOME: {
    name: "home",
    layout:"withPlainHeader",
    loadablComp:Home
  },
  LANDING: {
    name: "landing",
    authRequired:true,
    layout:"withHeader",
    loadablComp:Dashboard
  },
  DASHBOARD: {
    name: "my dashboard",
    authRequired:true,
    layout:"withHeader",
    loadablComp:Dashboard
  },
  USER_PROFILE: {
    name: "user profile",
    authRequired:true,
    layout:"withHeader",
    layoutOpt:{showLeftMenu:false},
    loadablComp: UserProfile,
  },
  ADT_AUTOMATION:{
    name: "adt automation",
    authRequired:true,
    layout:"withHeader",
    loadablComp: ADTAutomation
  },
  ADT_AUTOMATION_HISTORY:{
    name: "adt automation history",
    authRequired:true,
    layout:"withHeader",
    loadablComp: ADTAutomationHistory
  },
  SETTINGS: {
    name: "settings",
    basePath:"/settings",
    authRequired:true,
    layout:"withHeader",
    loadablComp: Settings,
    nextedRoutes:SettingsRoutes
  },
  AI_SERVICES: {
    name: "ai-services",
    authRequired:true,
    layout:"withHeader",
    layoutOpt:{showLeftMenu:false,contentClass:'page-content p-0'},
    nextedRoutes:AIServiceRoutes,
    loadablComp: AIService,
  },
  PATIENT360: {
    name: "patient360",
    authRequired:true,
    layout:"withHeader",
    loadablComp: Patient360,
  },
  PATIENTTRIAL: {
    name: "patienttrial",
    authRequired:true,
    layout:"withHeader",
    loadablComp: PatientTrial,
  },
  TRIAL_VIEW: {
    name: "patienttrial view",
    authRequired:true,
    layout:"withHeader",
    loadablComp: PatientTrial,
  },
  VIEW: {
    name: "patient view",
    authRequired:true,
    layout:"withHeader",
    loadablComp: Patient360,
  },
  SMART_SCHEDULER: {
    name: "smart scheduler",
    authRequired:true,
    layout:"withHeader",
    layoutOpt:{showLeftMenu:false,contentClass:'page-content p-0'},
    componentOpts:{pageType:'SMART_SCHEDULER'},
    loadablComp: SmartScheduler,
  },
  SMART_SCHEDULER_PATIENTS: {
    name: "smart scheduler patients",
    authRequired:true,
    layout:"withHeader",
    layoutOpt:{showLeftMenu:false,contentClass:'page-content p-0'},
    componentOpts:{pageType:'SMART_SCHEDULER_PATIENTS'},
    loadablComp: SmartScheduler,
  },
  EFAX: {
    name: "eFax",
    authRequired:true,
    layout:"withHeader",
    layoutOpt:{showLeftMenu:false,contentClass:'page-content p-0 efax'},
    loadablComp: EFax,
  },
  PRACTICES: {
    name: "practices",
    authRequired: true,
    layout:"withHeader",
    layoutOpt:{ showLeftMenu: false, contentClass: 'page-content p-0'},
    loadablComp: PracticeListingPage,
  },
  JOB_SCHEDULER_EXECUTED: {
    name: "jobSchedulerExecuted",
    authRequired: true,
    layout:"withHeader",
    layoutOpt:{ showLeftMenu: false, contentClass: 'page-content p-0'},
    loadablComp: ExecutedListingIndex,
  },
  REFERRAL360: {
    name: "referral360",
    authRequired: true,
    layout:"withHeader",
    layoutOpt:{ showLeftMenu: false, contentClass: 'page-content p-0'},
    loadablComp: Referral360,
  },
  DOWNLOAD_CENTER_UPLOAD: {
      name: "downnloadCenterUpload",
      authRequired: true,
      layout:"withHeader",
      layoutOpt:{ showLeftMenu: false, contentClass: 'page-content p-0'},
      loadablComp: DownloadCenterUpload,
  },
  DOWNLOAD_CENTER_VIEW_FILES: {
      name: "downloadCenterViewFiles",
      authRequired: true,
      layout:"withHeader",
      layoutOpt:{ showLeftMenu: false, contentClass: 'page-content p-0'},
      loadablComp: DownloadCenterViewFiles,
  }
};
Object.keys(Routes).forEach(rkey=>{
  if(GlobalRoutePath[rkey]){
    Routes[rkey] = {...Routes[rkey],...GlobalRoutePath[rkey]};
  }
  else{
    console.log('GlobalRoute Path info missing for',rkey)
  }
})

export const LANDING_PATH = {
  login:GlobalRoutePath.LANDING.path,
  nonLogin:GlobalRoutePath.HOME.path
}
export const AuthRequiredPaths = Object.values(Routes).filter(r=>r.authRequired).map(r=>r.nextedRoutes?[r.basePath,...Object.values(r.nextedRoutes).map(nr=>nr.fullPath)]:r.path).flat();
export const GlobalRoutes = Routes


